<template>
  <h2>股权债权价值分析报告</h2>
  <h3 class="form-title" style="color: red;">价值分析发现价值,帮用户实现资产流通和增值!</h3>
  <h3 style="padding-left:20px;color:red;">金融科技，大数据服务  诚信  客观 科学 严谨 高效</h3>
  <div class="paragraph">
    股权价值分析报告用途：
  </div>
  <div style="text-align:center">
    <img :src="require('/src/assets/images/equityUsage.png')" alt="股权价值分析报告用途" style="max-width:90%;margin:5px auto 5px auto;">
  </div>
  <div class="paragraph">
    提供word报告和PPT版本以及EXCEL工作底稿。每份定价9800元，如果企业复杂难度大，会酌情增加收费。
  </div>
  <div>
    请联系客服了解详情
    <div>
      联系方式:
      <ul>
        <li>电话：021-68828928, 15216609136</li>
        <li>E-mail：duanshihua@foxmail.com, 3450306099@qq.com</li>
        <li>QQ：3450306099, 2985437939</li>
        <li>微信：ksqj08, duanshihuaweixin</li>
      </ul>
    </div>
  </div>
  <!-- <div class="paragraph">
    专业价值分析目录：
  </div>
  <div class="qrcode-row">
    <img class="qrcode" :src="require('/src/assets/images/债权目录A.png')" />
    <img class="qrcode" :src="require('/src/assets/images/债权目录B.png')" />
  </div> -->
</template>

<script>
export default {
  name: "EquityTable",
  data() {
    return {};
  }
};
</script>
<style lang="less">
.form-title {
  padding-left: 15px;
}
.qrcode-row {
  text-align: center;
  .qrcode {
    width: 45%;
    max-width: 250px;
  }
}
</style>
